var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSoundwave(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SoundWave"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M41.4982 12.0312C44.005 12.0312 46.0372 14.0634 46.0372 16.5703V66.501C46.0372 69.0078 44.005 71.04 41.4982 71.04C38.9913 71.04 36.9591 69.0078 36.9591 66.501V16.5703C36.9591 14.0634 38.9913 12.0313 41.4982 12.0312ZM25.6105 24.2392C28.1171 24.2395 30.1495 26.2716 30.1495 28.7783V54.292C30.1493 56.7985 28.117 58.8308 25.6105 58.831C23.1037 58.831 21.0707 56.7987 21.0704 54.292V28.7783C21.0705 26.2715 23.1036 24.2392 25.6105 24.2392ZM57.3868 24.2392C59.8935 24.2395 61.9259 26.2716 61.9259 28.7783V54.291C61.9259 56.7977 59.8935 58.8298 57.3868 58.8301C54.8799 58.8301 52.8468 56.7979 52.8468 54.291V28.7783C52.8468 26.2714 54.8799 24.2392 57.3868 24.2392ZM9.72668 32.3779C12.2335 32.3779 14.2657 34.4101 14.2657 36.917V48.1865C14.2657 50.6934 12.2336 52.7256 9.72668 52.7256C7.21982 52.7255 5.18762 50.6934 5.18762 48.1865V36.917C5.18769 34.4102 7.21986 32.378 9.72668 32.3779ZM73.2745 30.1904C75.7814 30.1904 77.8135 32.2227 77.8136 34.7295V45.999C77.8136 48.5059 75.7814 50.5381 73.2745 50.5381C70.7676 50.5381 68.7355 48.5059 68.7355 45.999V34.7295C68.7356 32.2227 70.7677 30.1904 73.2745 30.1904Z",
    fill: "#0D70DC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundwave);
export default __webpack_public_path__ + "static/media/soundwave.e385c09b5d5bfad8aa0d02a64f24fd3b.svg";
export { ForwardRef as ReactComponent };